import PropTypes from 'prop-types';
import React, { Component } from 'react';
import config from 'config';

const { api: { media: { imagesURL, fallbackSilkPath } } } = config;

export default class Silk extends Component {

  static propTypes = {
    filename: PropTypes.string,
    fallbackImagePath: PropTypes.string
  }

  constructor(props) {
    super(props);
    const fallbackPath = props.fallbackImagePath ? 
      props.fallbackImagePath :
      fallbackSilkPath
      
    this.state = {
      fallbackPath,
      imageUrl: ''
    };
  }

  componentDidMount() {

    const imagePath = this.props.filename ? 
      `${imagesURL}images/silks/${this.props.filename}` :
      this.state.fallbackPath

    return this.setImageUrl(imagePath)
  }

  setImageUrl = imagePath => {
    return this.setState({
      imageUrl: imagePath 
    })
  }

  getImageElement = source => {
    //set fallback image path on error
    const onError = () => this.setImageUrl(this.state.fallbackPath)

    return source ? 
    <img src={this.state.imageUrl} onError={onError} /> :
    '';
  }

  render() {
    require("./Silk.scss");
    return (
      <div className="silk">
        { this.getImageElement(this.state.imageUrl) }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/Common/components/Silk.js